import { atom, useAtom } from 'jotai';

const currentSchoolyearIdSchoolIdAtom = atom<
  | {
      schoolyearId: string;
      schoolId: string;
    }
  | undefined
>(undefined);

export function useCurrentSchoolyearIdSchoolId() {
  const [currentSchoolyearIdSchoolId, setCurrentSchoolyearIdSchoolId] = useAtom(
    currentSchoolyearIdSchoolIdAtom,
  );
  return {
    currentSchoolyearId: currentSchoolyearIdSchoolId?.schoolyearId,
    currentSchoolId: currentSchoolyearIdSchoolId?.schoolId,
    setCurrentSchoolyearIdSchoolId,
    reset: () => setCurrentSchoolyearIdSchoolId(undefined),
  };
}
